// third-party

import { NavItemType } from "types";

import * as RouteHelper from "@utils/routes";

import TrackChanges from "@mui/icons-material/TrackChanges";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import { useTheme } from "@mui/material";

// ==============================|| ANALYSIS MENU ITEMS ||============================== //

export const getReportingNav = (projectId: string): NavItemType => {
  const theme = useTheme();
  return {
    id: "reporting",
    title: "Analytics", //TODO: change class to analytics
    icon: <TrackChanges sx={{ color: theme.palette.primary.main }} />,
    type: "group",
    children: [
      {
        id: "labour-hours",
        title: "Labour Hours",
        type: "item",
        icon: <WatchLaterIcon sx={{ color: theme.palette.primary.main }} />,
        url: RouteHelper.analyticsLabourHours(projectId),
      },
      {
        id: "spend",
        title: "Spend",
        type: "item",
        icon: <MonetizationOnIcon sx={{ color: theme.palette.primary.main }} />,
        url: RouteHelper.analyticsSpend(projectId),
      },
    ],
  };
};
